import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as mucHopDongAction from './actions'
import * as mucHopDongConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class MucHopDongEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Ten: "",
        IsDeleted: -1,
        StoresId: dbContext.getStoreId(),
      },
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.IsDeleted = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { mucHopDongDetailRequest } = this.props
    let mucHopDongId = this.getParam("muchopdong");
    var requestData = {
      mucHopDongId: mucHopDongId || 0
    }
    return mucHopDongDetailRequest(requestData);
  }
  UpdateMucHopDong = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên mức hợp đồng';
    }
    if (this.state.item.IsDeleted == -1) {
      formError.Status = 'Bạn chưa nhập trạng thái';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      this.props.mucHopDongUpdateRequest(item);
    }
  }
  BackToListMucHopDong = (item, e) => {
    this.props.history.push('/muchopdong');
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.mucHopDongEdit.type == mucHopDongConstant.MUC_HOPDONG_DETAIL_SUCCESS) {
      let { item } = nextProps.mucHopDongEdit;
      if (item.MucHopDongId && item.MucHopDongId > 0) {
        this.setState({
          item: item
        });
      }
    } else if (nextProps.mucHopDongEdit.type == mucHopDongConstant.MUC_HOPDONG_UPDATE_SUCCESS) {
      this.props.history.push("/muchopdong");
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      handleSubmit,
      mucHopDongEdit: {
        requesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting} >
          <Form>
          <FormGroup>
              <Label>Mã mức hợp đồng</Label>
              <Input type="text" name="Ma" id="maMucHopDong" placeholder="Mã mức hợp đồng" value={item.Ma || ''} readOnly={item.MucHopDongId > 0 ? true : false} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ma}</em>
            </FormGroup>
            <FormGroup>
              <Label for="">Tên mức hợp đồng</Label>
              <Input type="text" name="Ten" id="tenMucHopDong" placeholder="Tên mức hợp đồng" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup>
              <Label for="statusSelect">Trạng thái</Label>
              <select name="IsDeleted" id="statusSelect" className="form-control" value={item.IsDeleted} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>--Trạng thái--</option>
                <option value={0}>Hoạt động</option>
                <option value={1}>Ngừng hoạt động</option>
              </select>
              <em className="error invalid-feedback">{formError.Status}</em>
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListMucHopDong()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateMucHopDong()}
              permission={BtnPermissions.NganhHang.ADD_OR_UPDATE} />
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!requesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!requesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  mucHopDongEdit: state.mucHopDongEdit,
})
const connected = connect(mapStateToProps, {
  mucHopDongDetailRequest: mucHopDongAction.mucHopDongDetailRequest,
  mucHopDongUpdateRequest: mucHopDongAction.mucHopDongUpdateRequest,
  mucHopDongListRequest: mucHopDongAction.mucHopDongListRequest,
})(MucHopDongEdit)

const formed = reduxForm({
  form: 'mucHopDongEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/MucHopDong/MucHopDongEdit.js